<template>
  <div>
    <div class="menu-items">
      <a class="menu-item" @click="navigateTo('places')" v-bind:class="{'is-active': activeMenu === 'places'}">
        <img src="@/assets/icons/places.svg" alt="" v-if="activeMenu !== 'places'">
        <img src="@/assets/icons/places_white.svg" alt="" v-if="activeMenu === 'places'">
        Places
      </a>

      <a class="menu-item" @click="navigateTo('travel')" :class="{'is-active': activeMenu === 'travel'}">
        <img src="@/assets/icons/travel.svg" alt="" v-if="activeMenu !== 'travel'">
        <img src="@/assets/icons/travel_white.svg" alt="" v-if="activeMenu === 'travel'">
        Travel
      </a>

      <a class="menu-item" @click="navigateTo('')">
        <img src="@/assets/icons/reset.svg" alt="">
        Reset
      </a>
    </div>
  </div>
</template>

<script>
import Amenity from "@/mixins/Amenity";

export default {
  name: 'sidenav',
  mixins: [Amenity],
  data() {
    return {
      activeMenu: '',
    }
  },
  mounted() {
    this.activeMenu = this.$route.name;
  },
  methods: {
    navigateTo: function (url) {
      if (url === '') {
        this.$emit('resetClick', true);
      }
      if (this.activeMenu !== url) {
        this.activeMenu = url;
        const path = '/amenities/' + url;
        this.$router.push({
          path: path
        })
      } else {
        this.$emit('resetClick', true)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/amenities/Nav.vue